import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";

export default {
    name: "adminIndex",
    components: {
        MainLayout
    },

    data() {
        return {
            isLogin: true,
            id: this.$store.state.admin.admin['id'],
            adminForm: {
                name: ""
            }
        };
    },

    methods: {
        showAdminUpdate() {
            axios.get("/admin/update/" + this.id)
                .then(response => {
                    this.adminForm = response.data;
                })
                .catch(error => {
                    console.log("Show Admin Update API Error", error);
                });
        }
    },

    mounted() {
        this.showAdminUpdate();
    }
};